export default __webpack_public_path__ + "static/conselleria-18e52e1c2a1792b59e65ebe801415802.svg";